module.exports = __webpack_public_path__ + "static/media/hyperloop-train.a9d6de01.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/hyperloop-train.svg
// module id = 353
// module chunks = 0